import Button from "../../components/Button";
import Leiste from "../../components/Leiste";

/**
 * Nur wenn Spotify das Refresh-Token endgueltig abgelehnt hat.
 * Punkte/Verlauf bleiben erhalten — kein "erst abmelden" noetig.
 */
export default function ReauthBanner({ onReconnect }) {
  return (
    <Leiste icon="nochmal" titel="Spotify-Login abgelaufen" text="Punkte und Verlauf bleiben.">
      <Button variant="haupt" onClick={onReconnect}>
        Neu verbinden
      </Button>
    </Leiste>
  );
}
